import React, { Fragment } from "react";
import PropTypes from "prop-types";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Clear";

import InlineToolbar from "~/components/InlineToolbar";
import Form from "../Form";

const Header = styled(DialogTitle)({
  position: "relative",
  margin: 0,
  padding: 0,
  display: "flex",
  alignItems: "center"
});

const Title = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  marginLeft: 0,
  marginRight: "auto"
}));

const material = {
  title: "",
  linkText: "",
  sourcePath: "",
  renderType: "link",
  shortDescription: ""
};

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function NewModal({ classes, hideModal, onSubmit, kind }) {
  return (
    <>
      <Header>
        <Title variant="h6" id={`${kind}-modal-title`}>
          Eigenes Material verlinken
        </Title>

        <InlineToolbar>
          <StyledIconButton onClick={hideModal} size="large" aria-label="Schließen">
            <CloseIcon />
          </StyledIconButton>
        </InlineToolbar>
      </Header>

      <DialogContent>
        <Form onSubmit={onSubmit} material={material} canEdit={false} />
      </DialogContent>
    </>
  );
}

NewModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  classes: PropTypes.object,
  onSubmit: PropTypes.func,
  kind: PropTypes.string.isRequired
};

export default NewModal;
